export default __webpack_public_path__ + "static/news-img1-9cdb0d7ae49ba58007e89079dda25cab.jpg";